import React from "react";
import NavBar from "../components/NavBar";
import "../components/NavBar.css";
import "./Projects.css";
import Footer from "../components/Footer";
import "../components/Footer.css";
import SportsAppImage from "../components/SportsApp.png"; // Add your sports app screenshot

function Projects() {
  return (
    <div>
      <NavBar />
      <div className="projects-container">
        <div className="projects-grid">
          <div className="project-card">
            <a 
              href="https://sportsapp.wiedenterprise.com/login" 
              target="_blank" 
              rel="noopener noreferrer"
              className="project-image-link"
            >
              <div className="project-image-container">
                <img 
                  src={SportsAppImage} 
                  alt="Sports App" 
                  className="project-image" 
                />
              </div>
            </a>
            <h2>
              Sports App
              <span className="status-badge">Live</span>
            </h2>
            <p>
              A full-stack application for sports betting enthusiasts. 
              Features real-time odds, user authentication, and AI sports betting assistant.
            </p>
            <div className="project-tech">
              <span>React</span>
              <span>Node.js</span>
              <span>MongoDB</span>
              <span>LLM</span>
            </div>
            <a 
              href="https://sportsapp.wiedenterprise.com/login" 
              target="_blank" 
              rel="noopener noreferrer"
              className="view-project-btn"
            >
              View Project →
            </a>
          </div>
          
          {/* You can add more project cards here */}
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Projects;